import {
  Box,
  Card,
  CircularProgress,
  Container,
  Divider,
  FormControl,
  MenuItem,
  Pagination,
  Paper,
  Select,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { GetAllUserActivity } from '../network/User';
import { HeaderHeight, PageHeaderHeight } from '../Constants';
import Header from '../components/navbar/Header';
import Page from '../components/Page';
import NoDataAvailable from '../components/_dashboard/smartlock/NoDataAvailable';

const LoaderContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '50px'
});

const PageHeader = styled('Box')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 1,
  flexDirection: 'row',
  height: PageHeaderHeight,
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column'
  }
}));

const useStyles = makeStyles((theme) => ({
  menuItem: {
    fontSize: '14px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px'
    },
    minHeight: '20px',
    borderRadius: '8px',
    marginInline: theme.spacing(1)
  },
  tableCellStyle: {
    fontSize: {
      xs: '12px',
      md: '14px'
    },
    fontWeight: 700,
    padding: {
      xs: '8px',
      md: '16px'
    },
    textWrap: 'nowrap',
    textTransform: 'capitalize',
    backgroundColor: '#FFFFFF'
  },
  tablePaper: {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    backgroundColor: '#FFFFFF'
  },
  tableContainer: {
    flexGrow: 1,
    height: `calc(100vh - ${HeaderHeight + PageHeaderHeight + 56 + 40 + 50 + 18}px)`,
    overflow: 'auto'
  }
}));

export default function UserActivity() {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [userActivityData, setUserActivityData] = useState([]);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(false);
  const [filterValue, setFilterValue] = useState('');
  const [search, setSearch] = useState('');

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleFilter = (event) => {
    setPage(1);
    setFilterValue(event.target.value);
  };

  const getUserActivity = async (page, filterValue, search) => {
    setLoader(true);
    try {
      const res = await GetAllUserActivity(page, filterValue, search);
      if (res) {
        setUserActivityData(res?.data);
      }
    } catch (error) {
      console.log(error, 'err');
    } finally {
      setLoader(false);
    }
  };

  // const handleDeviceSearch = (value) => {
  //   setSearch(value);
  // };

  const SearchDevices = () => {
    setPage(1);
    getUserActivity(page, filterValue, search);
  };

  useEffect(() => {
    getUserActivity(page, filterValue, search);
    return () => {
      setUserActivityData((userActivityData) => []);
    };
  }, [page, filterValue]);

  return (
    <Page title="User Activity">
      <Header
        // handleSearch={handleDeviceSearch}
        handleSubmit={SearchDevices}
        name="User Activity"
        // showSearch
      />

      <Container maxWidth="false" disableGutters sx={{ padding: 0 }}>
        <Card sx={{ p: 3 }}>
          <PageHeader direction="row" spacing={2} alignItems="center" justifyContent="start">
            <Box sx={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              <FormControl data-testid="UserActivityFilter" size="small" sx={{ minWidth: 150 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <Typography sx={{ fontSize: { xs: '12px', sm: '14px' }, fontWeight: 600 }}>
                    Filter By
                  </Typography>
                  <Select
                    sx={{
                      fontSize: { xs: '12px', sm: '14px' },
                      fontWeight: '500',
                      minWidth: '130px',
                      borderRadius: '12px'
                    }}
                    labelId="filter-by"
                    data-testid="filterBy"
                    id="filter-by"
                    value={filterValue}
                    onChange={handleFilter}
                    IconComponent={ExpandMoreIcon}
                  >
                    <MenuItem value="" className={classes.menuItem}>
                      All
                    </MenuItem>
                    <MenuItem value="dashboard" className={classes.menuItem}>
                      Dashboard
                    </MenuItem>
                    <MenuItem value="trip" className={classes.menuItem}>
                      Trip Page
                    </MenuItem>
                    <MenuItem value="route" className={classes.menuItem}>
                      Route Page
                    </MenuItem>
                    <MenuItem value="vehicle" className={classes.menuItem}>
                      Vehicle Page
                    </MenuItem>
                    <MenuItem value="device" className={classes.menuItem}>
                      Device Page
                    </MenuItem>
                    <MenuItem value="control panel" className={classes.menuItem}>
                      Control Panel
                    </MenuItem>
                  </Select>
                </Box>
              </FormControl>
            </Box>
          </PageHeader>
          <Divider sx={{ my: 1 }} />
          <Paper className={classes.tablePaper}>
            <TableContainer className={classes.tableContainer}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tableCellStyle}>Page</TableCell>
                    <TableCell className={classes.tableCellStyle} align="left">
                      Action
                    </TableCell>
                    <TableCell className={classes.tableCellStyle} align="left">
                      Username
                    </TableCell>
                    <TableCell className={classes.tableCellStyle} align="left">
                      IP Address
                    </TableCell>
                    <TableCell className={classes.tableCellStyle} align="left">
                      Timestamp
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {loader && (
                    <TableRow>
                      <TableCell colSpan={10}>
                        <LoaderContainer>
                          <CircularProgress size={30} />
                        </LoaderContainer>
                      </TableCell>
                    </TableRow>
                  )}
                  {userActivityData?.data?.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={10}>
                        <NoDataAvailable data-testid="UserActivityNoData" />
                      </TableCell>
                    </TableRow>
                  ) : (
                    userActivityData?.data?.map((item) => (
                      <TableRow key={item.id}>
                        <TableCell
                          sx={{
                            minWidth: '10vw',
                            padding: {
                              xs: '8px',
                              md: '16px'
                            },
                            fontSize: {
                              xs: '12px',
                              md: '14px'
                            }
                          }}
                        >
                          {item?.page ? item?.page : '---'}
                        </TableCell>
                        <TableCell
                          sx={{
                            minWidth: '10vw',
                            padding: {
                              xs: '8px',
                              md: '16px'
                            },
                            fontSize: {
                              xs: '12px',
                              md: '14px'
                            }
                          }}
                          align="left"
                        >
                          {item?.description ? item?.description : '---'}
                        </TableCell>
                        <TableCell
                          sx={{
                            minWidth: '10vw',
                            padding: {
                              xs: '8px',
                              md: '16px'
                            },
                            fontSize: {
                              xs: '12px',
                              md: '14px'
                            }
                          }}
                          align="left"
                        >
                          {item?.user_name ? item?.user_name : '---'}
                        </TableCell>
                        <TableCell
                          sx={{
                            minWidth: '10vw',
                            padding: {
                              xs: '8px',
                              md: '16px'
                            },
                            fontSize: {
                              xs: '12px',
                              md: '14px'
                            }
                          }}
                          align="left"
                        >
                          {item?.ip_address ? item?.ip_address : '---'}
                        </TableCell>
                        <TableCell
                          sx={{
                            minWidth: '10vw',
                            padding: {
                              xs: '8px',
                              md: '16px'
                            },
                            fontSize: {
                              xs: '12px',
                              md: '14px'
                            }
                          }}
                          align="left"
                        >
                          {item?.createdAt ? (
                            moment(item?.createdAt)?.format('DD-MM-YYYY hh:mm:ss a')
                          ) : (
                            <Typography>--</Typography>
                          )}
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>

          {userActivityData?.data?.length !== 0 && (
            <Stack
              sx={{
                marginTop: '10px',
                marginBottom: '10px'
              }}
            >
              <Pagination
                style={{ display: 'flex', justifyContent: 'flex-end' }}
                count={userActivityData?.totalPages}
                showFirstButton
                showLastButton
                onChange={handlePageChange}
                page={page}
                total={userActivityData?.total}
              />
            </Stack>
          )}
        </Card>
      </Container>
    </Page>
  );
}
